
(function () {
  const gridSelector = "#product-grid";
  const shownCountSelector = ".js-collection-length";
  const loadMoreBtnSelector = ".js-load-more";

  let isLoading = false;

  /* ---------------------------
     ARIA live region
  ---------------------------- */
  function getLiveRegion() {
    let live = document.getElementById("load-more-live");
    if (!live) {
      live = document.createElement("div");
      live.id = "load-more-live";
      live.className = "visually-hidden";
      live.setAttribute("aria-live", "polite");
      live.setAttribute("aria-atomic", "true");
      document.body.appendChild(live);
    }
    return live;
  }

  function announce(msg) {
    getLiveRegion().textContent = msg;
  }

  /* ---------------------------
     Helpers
  ---------------------------- */
  function getGrid() {
    return document.querySelector(gridSelector);
  }

  function getLoadMoreBtn() {
    return document.querySelector(loadMoreBtnSelector);
  }

  function updateShownCount() {
    const grid = getGrid();
    const countEl = document.querySelector(shownCountSelector);
    if (!grid || !countEl) return;
    countEl.textContent = grid.querySelectorAll("li.grid__item").length;
  }

  function updateProductAriaLabels() {
    const items = document.querySelectorAll("#product-grid li.grid__item");
    items.forEach((item, index) => {
      item.setAttribute(
        "aria-label",
        `Product ${index + 1} of ${items.length}`
      );
    });
  }

  function setButtonState(btn, loading) {
    if (!btn) return;

    const textSpan = btn.querySelector("span");
    if (loading) {
      btn.setAttribute("aria-disabled", "true");
      btn.setAttribute("aria-busy", "true");
      btn.dataset.originalText = textSpan.textContent;
      textSpan.textContent = "Loading…";
    } else {
      btn.removeAttribute("aria-busy");
      btn.setAttribute("aria-disabled", "false");
      textSpan.textContent = btn.dataset.originalText || "Load more";
    }
  }

  function hideButton(btn) {
    const wrap = btn.closest(".load-more_wrap");
    if (wrap) wrap.style.display = "none";
  }

  /* ---------------------------
     Extract products + next URL
  ---------------------------- */
  function parseHTML(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const newItems = doc.querySelectorAll("#product-grid li.grid__item");

    let nextUrl = "";
    const relNext = doc.querySelector('link[rel="next"]');
    if (relNext) nextUrl = relNext.getAttribute("href");

    return { newItems, nextUrl };
  }

  /* ---------------------------
     MAIN FUNCTION (global)
  ---------------------------- */
  window.loadMoreProducts = async function (nextUrl, event) {
    event.preventDefault();
    if (isLoading) return;

    const grid = getGrid();
    const btn = getLoadMoreBtn();
    if (!grid || !btn) return;

    isLoading = true;
    setButtonState(btn, true);
    announce("Loading more products…");

    document
      .getElementById("ProductGridContainer")
      ?.setAttribute("aria-busy", "true");

    try {
      const response = await fetch(nextUrl);
      const html = await response.text();

      const beforeCount = grid.children.length;
      const { newItems, nextUrl: newNextUrl } = parseHTML(html);

      if (!newItems.length) {
        hideButton(btn);
        announce("All products loaded.");
        return;
      }

      newItems.forEach((item) => grid.appendChild(item));

      updateShownCount();
      updateProductAriaLabels();

      const afterCount = grid.children.length;
      announce(
        `${afterCount - beforeCount} more products loaded. Now showing ${afterCount}.`
      );

      // Update next URL or hide button
      if (newNextUrl) {

  const absolute = new URL(newNextUrl, window.location.origin).toString();

  // update href
  btn.setAttribute("href", absolute);

  // remove previous listeners (optional safety)
  btn.onclick = null;
btn.href = absolute;

btn.addEventListener("click", (e) => {
  e.preventDefault();
  loadMoreProducts(btn.href, e);
});

} else {

  hideButton(btn);

}

      // Focus first new product
      const firstNew = newItems[0];
      firstNew.setAttribute("tabindex", "-1");
      firstNew.focus();
      firstNew.removeAttribute("tabindex");
    } catch (e) {
      console.error(e);
      announce("Error loading products.");
    } finally {
      isLoading = false;
      setButtonState(btn, false);
      document
        .getElementById("ProductGridContainer")
        ?.removeAttribute("aria-busy");
    }
  };

  /* ---------------------------
     Init
  ---------------------------- */
  document.addEventListener("DOMContentLoaded", () => {
    updateShownCount();
    updateProductAriaLabels();
  });
})();

(function () {

  function updateProductCount() {
    const grid = document.querySelector("#product-grid");
    if (!grid) return;

    const count = grid.querySelectorAll("li.grid__item").length;

    // Update hidden input only if changed
    const input = document.querySelector(".js-collection-length");
    if (input && input.value != count) {
      input.value = count;
    }

    // Update span only if changed
    const span = document.querySelector(".js-collection-count-text");
    if (span && span.textContent != count) {
      span.textContent = count;
    }
  }

  document.addEventListener("DOMContentLoaded", updateProductCount);
  document.addEventListener("facet:updated", updateProductCount);

  const container = document.getElementById("ProductGridContainer");
  if (container) {
    const observer = new MutationObserver(() => {
      updateProductCount();
    });

    observer.observe(container, {
      childList: true,
      subtree: true
    });
  }

})();